export default __webpack_public_path__ + "static/media/img4.214e3cd0.webp";